import { useEffect } from 'react';

/**
 * Custom hook to listen for CNH Browser notification events and navigate to vehicle-list
 * with notification data encoded in URL parameters.
 *
 * Listens to: cnh:action-view-pipeline
 *
 * Expected payload structure:
 * {
 *   userId: string,
 *   vehicleListIds: string[],
 *   bookmarkids: string[],
 *   notificationTitle: string,
 *   earlistNotificationTimeStamp: string,
 *   eventFilter: {
 *     and: Array<condition | { or: Array<condition> }>,
 *     or: Array<condition | { and: Array<condition> }>
 *   }
 * }
 *
 * eventFilter examples:
 * - Simple AND: { and: [{ modelYear: "2025" }, { brandName: "lexus" }] }
 * - Simple OR: { or: [{ modelYear: "2025" }, { modelYear: "2026" }] }
 * - Complex nested: { and: [{ or: [{ modelYear: "2024" }, { modelYear: "2025" }] }, { brandName: "lexus" }] }
 */
const useNotificationListener = () => {
  useEffect(() => {
    const handleCNHPipelineEvent = (event) => {
      const cnhEvent = event;
      const payload = cnhEvent.detail;

      const encodedData = encodeURIComponent(JSON.stringify(payload));

      window.location.href = `/vehicle-list?notificationDetails=${encodedData}`;
    };

    window.addEventListener('cnh:action-view-pipeline', handleCNHPipelineEvent);

    // Test: Fire event after 10 seconds with sample data
    // const testTimeout = setTimeout(() => {
    //   const bookmarkids = ['0dnpI1IQDR', 'nmUwYWoG2X'];

    //   window.dispatchEvent(
    //     new CustomEvent('cnh:action-view-pipeline', {
    //       detail: {
    //         userId: '636444',
    //         vehicleListIds: ['62uKfnXiE0'],
    //         bookmarkids,
    //         notificationTitle: 'Notifications List Name',
    //         earlistNotificationTimeStamp: '2026-01-09T21:41:40.993307',
    //         eventFilter: {
    //           and: [
    //             {
    //               or: [{ modelYear: '2024' }, { modelYear: '2025' }],
    //             },
    //             { brandName: 'toyota' },
    //           ],
    //         },
    //       },
    //     }),
    //   );
    // }, 5000);

    return () => {
      window.removeEventListener('cnh:action-view-pipeline', handleCNHPipelineEvent);
      // clearTimeout(testTimeout);
    };
  }, []);
};

export default useNotificationListener;
